import React, {useState} from 'react';
import {firebase} from '../../../firebase/firebaseConfig';

//Material UI imports
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

export default function Searchbox(props) {
  const [localSearch, setLocalSearch] = useState('')
  const classes = useStyles();

  const handleChange = (e) => {
    setLocalSearch(e.target.value);
    if (e.target.value.length === 0) props.setSearch(e.target.value);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    firebase.analytics().logEvent('search', {search_term: localSearch});
    props.setSearch(localSearch);
  }

  return (
    <Paper component="form" className={classes.root} onSubmit={handleSubmit}>
      <InputBase
        className={classes.input}
        placeholder="Search keywords or location..."
        inputProps={{ 'aria-label': 'search by keywords or location' }}
        value={localSearch}
        onChange={handleChange}
      />
      <IconButton type="submit" className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
      <Divider className={classes.divider} orientation="vertical" />
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    maxWidth: 400,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '2em'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));